module.exports = __webpack_public_path__ + "img/cal-copper-iud.b600b1a9.png";